import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import { Container } from 'Components/Atoms/ContainerDeprecated/Container';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import Relations from 'Components/Organisms/Relations/Relations';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { ROUTE } from 'Services/Route/Route.types';
import { fetchAllRelations } from 'Store/FieldManagement/Actions';
import { getAllDatasets } from 'Store/FieldManagement/Selectors';

const RelationPage = ({datasets, ...props}: any) => {
    useEffect(() => {
        props.fetchAllRelations();
    }, []);

    return (
        <PageTemplate>
            <Helmet>
                <title>Relation - Growing People B.V.</title>
            </Helmet>

            <Container>
                <PageHeader
                    breadcrumbs={
                        <Breadcrumbs>
                            <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                            <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                            <BreadcrumbItem>Relaties</BreadcrumbItem>
                        </Breadcrumbs>
                    }
                />

                <Relations />
                
                { !datasets && <div>Voeg een dataset toe voordat je een relatie kan toevoegen.</div> }
            </Container>
        </PageTemplate>
    )
}

export default connect(
    (state: any) => ({
        datasets: getAllDatasets(state)
    }), {
        fetchAllRelations
    }
)(RelationPage);